import { ColorProps } from '../Attribute/components/Color'
import rgbTo, { ColorFormat } from '../Attribute/components/Color/utils'

interface CopyProps {
  artboardWidth: number
  artboardHeight: number
  color?: ColorProps
  colorFormat?: ColorFormat
}

const copy = ({
  artboardWidth,
  artboardHeight,
  color,
  colorFormat,
}: CopyProps) => {
  const colorCopy = color ? `\nColor: ${rgbTo(colorFormat, color)}` : ``

  return `Width: ${artboardWidth}\nHeight: ${artboardHeight}` + colorCopy
}

export default copy
